import '../stylesheets/Menus.css';

export default function InstructionsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="instructions-overlay">
      <div className="instructions-modal">
        <div className="instructions-modal-header">
          <h2 className="instructions-title">How to Play</h2>
          <button
            type="button"
            className="start-menu-button instructions-close-button"
            onClick={onClose}
          >
            Close
          </button>
        </div>

        <div className="instructions-body">
          <h3>Call It Out Loud: The Virtual Anti-Bullying Game</h3>
          <p><em>See it. Name it. Flip the Script.</em></p>
          <p>
            An interactive, heart-opening dialogue game for students ready to speak up,
            stand tall, and change the culture.
          </p>

          <hr />

          <h4>🎯 Objective</h4>
          <p>
            There are no winners or losers in <strong>Call It Out</strong>. The purpose is
            simple: to speak, listen, and grow together. Through honest dialogue,
            courage, and laughter, players build empathy, leadership, and the confidence
            to stand up — for themselves and for others.
          </p>

          <h4>🤝 Creating a Safe & Brave Space</h4>
          <p>Before you begin, agree on two shared principles:</p>
          <ul>
            <li>
              🕊️ <strong>Respect &amp; Safety:</strong> No judgment, teasing, or advice
              unless invited. Everyone’s truth is welcome.
            </li>
            <li>
              🔒 <strong>Confidentiality:</strong> What is said in this circle stays in
              this circle.
            </li>
          </ul>
          <p>
            These agreements create a brave space where honesty and kindness can
            coexist. Share as much or as little as feels right. If something feels too
            intense, choose a <strong>Drop the Anchor</strong> prompt to pause, breathe,
            and reground.
          </p>

          <h4>🧭 Setup</h4>
          <p>
            Gather your group — classmates, friends, or teammates.
            Best with <strong>4–7 players</strong>, but flexible for virtual classrooms
            or youth groups.
          </p>
          <p>
            Choose a comfortable, private space where everyone feels safe to share.
          </p>

          <h4>🕹️ Gameplay</h4>
          <ol>
            <li>
              <strong>1. Start the Game:</strong> Open the Call It Out virtual game and choose
              who will go first. The first player clicks <strong>Play Now</strong>, then
              <strong> Start Game</strong>, and enters their name. An ID code will appear
              on the right side of the screen. Other players join by entering their name
              and the shared ID, then clicking <strong>Join Game</strong>.
            </li>
            <br/>
            <li>
              <strong>2. Taking Turns:</strong> Each round, one player becomes the Leader.
              The Leader clicks <strong>Roll &amp; Move</strong> to land on a category,
              then clicks <strong>Draw Card</strong> to reveal a question or prompt.
            </li>
            <br/>
            <li>
              <strong>3. Sharing Your Voice:</strong> The Leader reads the card aloud and
              answers first — with honesty and heart. Then, one by one, each player
              responds. Listen deeply and allow space for reflection.
            </li>
            <br/>
            <li>
              <strong>4. Closing the Round:</strong> When everyone has shared, click
              <strong> End Turn</strong> to pass the Leader role to the next player.
            </li>
            <br/>
            <li>
              Play for as long or as briefly as you wish — every round matters. Even a
              short conversation can create meaningful connection and change.
            </li>
          </ol>

          <h4>💗 Categories</h4>
          <ul className="instructions-categories">
            <li>🎤 Real Talk — Speak Your Truth</li>
            <li>🦸 Stand Up &amp; Speak Out — Find Your Voice</li>
            <li>🎭 Behind the Mask — Look Deeper</li>
            <li>⚡ Power Moves — Lead with Courage</li>
            <li>🔄 Flip the Script — Change the Story</li>
            <li>🌊 Ripple Effect — See Your Impact</li>
            <li>🎙️ Drop the Mic — Speak Your Power</li>
            <li>🎉 Pop-Off Play! — Lighten the Mood</li>
            <li>🩷 Self Care Squad — Recharge &amp; Reflect</li>
            <li>⚓ Drop the Anchor — Calm &amp; Recenter</li>
          </ul>

          <h4>🌈 Closing the Game</h4>
          <p>When you’re ready to end, invite each player to share:</p>
          <ul>
            <li>✨ Something they learned</li>
            <li>💭 Something they felt</li>
            <li>💪 Something they’re taking with them</li>
          </ul>
          <p>
            Take a deep breath together. Every moment of honesty is a step toward
            courage, kindness, and change.
          </p>

          <h4>🌿 A Gentle Reminder</h4>
          <p>
            <strong>Call It Out</strong> is a game for growth, courage, and community.
            It is not a replacement for therapy — but it can be a powerful step toward it.
            You are never alone. Speaking your truth is how healing begins.
          </p>
          <p><strong>💛 Let's put an end to bullying together. You all matter.</strong></p>
        </div>

      </div>
    </div>
  );
}


